import type { ApiConfig } from '../api/types';

import { getServerTime } from './serverTime';

const DEFAULT_EDIT_TIMEZONE = 'Asia/Ho_Chi_Minh';

const dayFormatters = new Map<string, Intl.DateTimeFormat>();

// Without the server's rules (an older backend, or no config loaded yet) editing is held to the same
// day in the company zone, the safe default the spec sets; the server enforces the real rules anyway.
// The edit window runs from the moment the message was sent, so editing it again never extends it.
export function getIsInEditWindow(config: ApiConfig | undefined, messageDate: number) {
  const now = getServerTime();
  if (config?.editWindow === 'duration' && config.editTimeLimit !== undefined) {
    return now - messageDate <= config.editTimeLimit;
  }

  const formatter = getDayFormatter(config?.editTimezone || DEFAULT_EDIT_TIMEZONE);
  return formatter.format(messageDate * 1000) === formatter.format(now * 1000);
}

function getDayFormatter(timeZone: string) {
  let formatter = dayFormatters.get(timeZone);
  if (formatter) return formatter;

  try {
    formatter = new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' });
  } catch (err) {
    // An unknown zone name from the server must not break the menu; fall back to the company zone
    formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: DEFAULT_EDIT_TIMEZONE, year: 'numeric', month: '2-digit', day: '2-digit',
    });
  }

  dayFormatters.set(timeZone, formatter);
  return formatter;
}
